import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ReactMarkdown from 'react-markdown'
import { request } from '../utils/request'
import Layout from '../components/layout'
import SEO from '../components/seo'

const Article = () => {
  const { id } = useParams() as any
  const [ state, setState ] = useState({ fetching: true })
  const [ article, setArticle ] = useState<any>({ cover: {} })

  useEffect(() => {
    const fetchArticle = async () => {
      const response = await request.article(id)
      if (response.data && response.data.data && response.data.data.article) {
        if (response.data.data.article.publish) {
          setArticle(response.data.data.article)
        }
      }
      setState({ ...state, fetching: false })
    }
    fetchArticle()
  }, [])

  const extractArticle = () => {
    if (state.fetching) {
      return (
        <div className="container content section">
          <p>Loading content...</p>
        </div>
      )
    }

    if (article.id) {
      return (
        <div key={article.id}>
          <div style={{ height: '300px' }}>
            <img style={{ objectFit: 'cover', height: '100%', width: '100%' }} 
              src={process.env.REACT_APP_IMAGE_BASE_URL + article.cover.url} 
              alt={article.title} />
          </div>
          <div className="container content section">
            <h1 className="title">{article.title}</h1>
            <ReactMarkdown 
              className="article"
              source={article.description}
              transformImageUri={uri =>
                uri.startsWith("http") ? uri : `${process.env.REACT_APP_IMAGE_BASE_URL}${uri}`
              }
            />
          </div>
        </div>
      )
    }
    
    return (
      <div className="container content section">
        <h1 className="title">Not Found</h1>
        <p>Sorry, the page you visited does not exists.</p>
      </div>
    )
  }

  return (
    <Layout>
      <SEO title='Article' />
      <div style={{
        marginTop: "5.5rem"
      }}>
        {extractArticle()}
      </div>
    </Layout>
  )
}

export default Article